import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { RecomendationProducts } from "../../constants/Landing";
import { useBgHighlightLanding } from "../../themes/colors";
import SimpleProductCard from "../card/product/SimpleProductCard";
import SimpleProductCardSkeleton from "../card/product/SimpleProductCardSkeleton";

const ProductsRecommendationSection = ({
  productRecomendations,
  isProductRecomendationsLoading,
}: {
  productRecomendations: RecomendationProducts[] | undefined;
  isProductRecomendationsLoading: boolean;
}) => {
  const bgHighlight = useBgHighlightLanding();

  return (
    <Flex
      direction={{ base: "column", xl: "row" }}
      alignItems={"center"}
      gap={"20px"}
      justifyContent={"space-between"}
    >
      <Text
        w={"100%"}
        textStyle={"h-title"}
        textAlign={{ base: "center", xl: "left" }}
        flex={1}
      >
        Rekomendasi barang buat kamu
      </Text>

      <SimpleGrid
        columns={[2, null, null, 4]}
        backgroundColor={bgHighlight}
        flex={2}
        rounded={{ base: "12px", lg: "16px" }}
        px={"20px"}
        py={"20px"}
        gap={{ base: "30px", sm: "60px", md: "20px" }}
      >
        {isProductRecomendationsLoading
          ? Array.from({ length: 4 }).map((_, index) => (
              <SimpleProductCardSkeleton key={index} />
            ))
          : productRecomendations &&
            productRecomendations.map((product, index) => (
              <SimpleProductCard
                key={index}
                imageSrc={
                  product?.main_picture
                    ? `${process.env.REACT_APP_MEDIA_URL}${product?.main_picture}`
                    : ""
                }
                name={product.name}
                lowestPrice={product?.lowest_price}
                slug={product?.slug}
              />
            ))}
      </SimpleGrid>
    </Flex>
  );
};

export default ProductsRecommendationSection;
